import React, { Component } from "react";
import PropTypes from "prop-types";
import "./ToastNotification.css";

class ToastNotification extends Component {
  state = {
    isShowToast: false,
    closeClassName: "",
    message: null
  }

  componentDidMount() {
    if(this.props.isShowToast) {      
      this.handleToastStatus();
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.toastId !== prevProps.toastId && this.props.isShowToast) {
      if(this.state.isShowToast) {
        if(this.setTimeout) {
          clearTimeout(this.setTimeout);
        }

        this.handleClearToast();       
        this.setTimeout = setTimeout(() => {
          this.handleToastStatus();
        }, 1000);
      } else {
        this.handleToastStatus();
      }      
    }
  }

  handleCloseToast = () => {    
    this.setState({ 
      closeClassName: " close-hide-toast"
    });
    this.props.onClose();
    this.setTimeout = setTimeout(() => {
      this.setState({ 
        isShowToast:false, 
        closeClassName: "", 
        message: null,
        variant: null 
      });
    },500);
    if(this.setTimeout) {
      clearTimeout(this.setTimeout);
    }
  }

  handleToastStatus = () => {
    this.setState({ 
      isShowToast: this.props.isShowToast, 
      closeClassName: " show-toast", 
      message: this.props.message,
      variant: this.props.variant
    });
    this.setTimeout = setTimeout(() => {
      this.handleClearToast();
    }, 3000);
  }

  componentWillUnmount() {
    if(this.setTimeout) {
      clearTimeout(this.setTimeout);
    }
  }

  handleClearToast = () => {
    this.setState({ closeClassName: " auto-hide-toast" });

    this.setTimeout = setTimeout(() => {
      this.setState({ 
        isShowToast:false, 
        closeClassName: "", 
        message: null,
        variant: null 
      });
    },500);
  }

  render() {
    return (
      <div className={"toast-notification toast-" + this.state.variant + this.state.closeClassName }>
        <div className="toast-icon"></div>
        <div className="vertical-line"></div>
        <div className="toast-message">{this.state.message}</div>
        <div className="toast-remove" onClick={this.handleCloseToast}></div>               
      </div>
    )
  }
}

ToastNotification.propTypes = {
  message: PropTypes.node,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'progress', 'regret']).isRequired
};
export default ToastNotification;


// WEBPACK FOOTER //
// ./src/components/UI/ToastNotification/ToastNotification.js